import { CustomComponentProps } from "utils/types/generalTypes";

export type InputTypes = "text" | "email" | "password" | "number";

export type InputProps = CustomComponentProps & {
    handleChange: Function;
    value: string;
    label?: string;
    placeHolder?: string;
    type?: InputTypes;
    loading?: boolean;
    rounded?: boolean;
    error?: string;
    disabled?: boolean;
};

const Input = ({
    value,
    handleChange,
    label,
    placeHolder,
    type = "text",
    error,
    loading = false,
    rounded = false,
    disabled = false,
    className,
    style
}: InputProps) => {
    return (
        <div className={`field ${className}`} style={style}>
            {label ? <label>{label}</label> : ""}

            <div className={`control ${loading ? "is-loading" : ""}`}>
                <input
                    type={type}
                    className={`input ${rounded ? "is-rounded" : ""}`}
                    onChange={(e) => handleChange(e)}
                    value={value}
                    placeholder={placeHolder}
                    disabled={disabled}
                />
            </div>
            <p className={`field-error ${error ? "" : "is-hidden"}`}>{error}</p>
        </div>
    );
};

export default Input;
